<template lang="pug">
	.v-not-found-id.not-found-id(v-if="data")
		.container
			.not-found-id__content
				h1.not-found-id__title(v-if="data.title" ) {{ data.title }}
				v-search-small.not-found-id__search(data-source="/local/assets/dist/fixtures/search-small.json")
</template>


<script>
import sourceMixin from '../components/mixins/v-mixin-source.vue';

export default {

	mixins: [
		sourceMixin,
	],

	data() {
		return {
			data: null,
		}
	},

	methods: {
		dataSet(data) {
			this.data = data;
		}
	},

}
</script>